const formatFullName = (firstName, lastName) => {
  return ((firstName ? firstName + " " : "") + (lastName ? lastName : "")).trim();
};
export { formatFullName };